<form #blockInputs="ngForm">
  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.HTML_BLOCK.RAW' | translate }}</glxy-label>
    <textarea
      #htmlModel="ngModel"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="25"
      [(ngModel)]="content.rawHtml"
      name="Raw HTML"
      sharedContainsValidDynamicContent
    ></textarea>
  </glxy-form-field>
  <glxy-error *ngIf="htmlModel.hasError('invalidDynamicComponent') && htmlModel.touched">
    {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
  </glxy-error>
</form>
